import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { StdDciGridOutputModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { SDLinkModel, StrjsonDocIDModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { NotificationService } from "src/app/Service/notification.service";
import { GetSDListforGrid } from "src/app/ViewModel/ScheduleDefinitionModel";
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileUploadLibrary } from "src/app/Service/file/file.service";
import { BulkScheduleUploadComponent } from "../bulk_schedule_upload/bulk-schedule-upload.component";
import { StandardDrawingDialogComponent } from '../standard-drawing-dialog/standard-drawing-dialog.component';
import { DatePipe } from '@angular/common';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { Subscription } from "rxjs";
import { StandardDrawingLinkComponent } from './standard-drawing-link/standard-drawing-link.component';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from "src/app/ViewModel/ProjectElementsModel";

@Component({
  selector: 'app-standard-drawing',
  templateUrl: './standard-drawing.component.html',
  styleUrls: ['./standard-drawing.component.css']
})

export class StandardDrawingComponent implements OnInit, OnDestroy {
  projectId: number = 0;
  enableFilter = false;
  groupId!: number;
  public selectedfiles: any[] = [];
  public standardList: any[] = [];
  public stdDciListforGrid: any[] = [];
  memberId!: number;
  selectedOption: string = 'standard';
  public linkedList: StdDciGridOutputModel[] = [];
  public alllinkedList: StdDciGridOutputModel[] = [];
  selectionAction: any[] = [];
  public selectedworkflow = [];
  workflowList: WorkflowTemplateModel[] = [];
  selectedWorkflownumber: number = 0;
  selectedgroup_Id: number = 0;
  selectedReleaseId: number = 0;
  public addeddata: any[] = [];
  public isCommonProject: boolean = false;
  SDdocIDforLink: StrjsonDocIDModel[] = [];
  UnsubscribeArray: Subscription[] = [];
  public skip: number = 0;
  eleValue: IProjectElementDetailsOutput[] = [];

  constructor(private _notificationService: NotificationService, private dialog: MatDialog, private _commonService: CommonService,
    private _scheduleDocService: ScheduleDocumentService, public datepipe: DatePipe,) { }

  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    if (this.projectId == 0) {
      this.isCommonProject = true;
    }
    this.loadStandardDrawingList();
    this.getWorkflowDetails();
  }

  loadStandardDrawingList() {
    let inputstddraw: GetSDListforGrid = { intProjectID: this.projectId, intGroupID: this.groupId, strSearchFor: "NOT-LINKED-DOCS" };
    let getStdDciList = this._scheduleDocService.GetStdDciListForGrid(inputstddraw).subscribe((res: StdDciGridOutputModel[]) => {
      this.standardList = res;
    });
    this.UnsubscribeArray.push(getStdDciList);
  }

  loadLinkedList() {
    let inputstddraw: GetSDListforGrid = { intProjectID: this.projectId, intGroupID: this.groupId, strSearchFor: "LINKED-DOCS" };
    let getStdDciLinkedlist = this._scheduleDocService.GetStdDciListForGrid(inputstddraw).subscribe((res: StdDciGridOutputModel[]) => {
      this.linkedList = res;
      this.alllinkedList = res;
    });
    this.UnsubscribeArray.push(getStdDciLinkedlist);
  }

  viewAttachmentClick(data: any) {
    this.dialog.open(FileListComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '70%',
      data: {
        projectId: 0,
        docId: data.doc_Id,
        revisionNo: data.revision_No,
        libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId,
        isDeleteEnable: false,
        documentNo: data.doc_No
      },
    });
  }

  public uploadattachmentClick(data: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: {
        projectId: 0,
        docId: data.doc_Id,
        revisionNo: data.revision_No,
        moduleName: 'EDMS',
        libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId,
        documents: [{
          value: data.doc_Id,
          text: data.doc_No,
          revisionNo: data.revision_No,
          task_SNo: 1
        }],
        isEditable: false,
        isStdDCI: true
      },
    });
    dialog.afterClosed().subscribe((res: any) => {
    });
  }

  viewLinkedAttachment(data: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: {
        projectId: this.projectId,
        docId: data.doc_Id,
        revisionNo: data.revision_No,
        libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId,
        isDeleteEnable: false,
        documentNo: data.doc_No
      },
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  getWorkflowDetails() {
    let getWfDetails = this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
      this.workflowList = x;
      this.workflowList = this.workflowList.filter(x => x.scheduleType == 3);
    });
    this.UnsubscribeArray.push(getWfDetails);
  }

  selectedworkflowvalue(event: any) {
    this.selectedWorkflownumber = event.additionalValues.additionalValues.workflowId;
  }

  closeworkflowTab(event: any) {
    this.selectedWorkflownumber = 0;
  }

  onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
        this.selectionAction.push(element.dataItem);
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { doc_Id: any; revision_No: any; }; }) => {
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (element.dataItem.doc_Id == this.selectionAction[i].doc_Id && element.dataItem.revision_No == this.selectionAction[i].revision_No) {
            this.selectionAction.splice(i, 1);
          }
        }
      });
    }
  }

  public pageChange(event: PageChangeEvent): void {
    this.selectionAction = [];
    this.selectedfiles = [];
  }

  get isStandardDraw(): boolean {
    return this.selectedOption === 'standard';
  };

  changeButtonToggle(event: { value: string; }) {
    this.selectedOption = event.value;
    this.enableFilter = false;
    if (this.selectedOption == 'standard') {
      this.loadStandardDrawingList();

    }
    else {
      this.loadLinkedList();
    }
  }

  createdocument() {
    let dialogRef = this.dialog.open(BulkScheduleUploadComponent,
      {
        panelClass: 'mat-dialog-primary',
        data: { num: 1, isStdDCI: true }
      });
    dialogRef.afterClosed().subscribe(res => {
      if (res)
        this.createdocument();
      else
        this.loadStandardDrawingList();
    })
  }

public eleobj: any[]=[];
  addDocFromGrid() 
  {
    if(this.selectionAction.length > 0)
    {
      let dialogRef = this.dialog.open(StandardDrawingLinkComponent, {
        panelClass: 'mat-dialog-content',
        width: '100%'
      })
      dialogRef.afterClosed().subscribe((data) => 
      {
        if (data) 
        {
          this.eleValue = data.eleValue;
          this.selectedWorkflownumber = data.selectedWorkflownumber;
          this.selectedgroup_Id = data.selectedgroup_Id;
          this.selectedReleaseId = data.selectedReleaseId;
  
          this.eleValue.forEach(x=>
            {
              let i = this.eleValue.indexOf(x);
              let eleobj = {
                "DE_Id" : this.eleValue[i].deId,
                "DED_Id" : this.eleValue[i].dedId,
                "Is_Active" : true,
                "Created_By" : this.memberId,
                "Created_On" : new Date(),
                "Modified_By" : null,
                "Modified_On" : null,
                "Is_System_Data" : true
              };
              this.eleobj.push(eleobj);
            });
  
          this.selectedfiles = [];
          this.SDdocIDforLink = [];
          if (this.selectionAction.length > 0) 
          {
            this.selectionAction.forEach(element => {
              if (element.isSelected) {
                this.selectedfiles.push(element);
              }
            });
            this.selectedfiles.forEach(element => {
      
              let i = this.selectedfiles.indexOf(element);
              let obj = {
                "doc_id": this.selectedfiles[i].doc_Id
              };
              this.SDdocIDforLink.push(obj);
            });
            if (this.selectedWorkflownumber != 0) {
              let docIdinput: SDLinkModel =
              {
                intProjectId: this.projectId,
                intGroupID: this.groupId,
                strjsonDocID: JSON.stringify(this.SDdocIDforLink),
                strjsonElement: JSON.stringify(this.eleobj),
                intWFID: this.selectedWorkflownumber,
                intApproval: this.selectedgroup_Id,
                intReleaseId: this.selectedReleaseId,
                intUID: this.memberId
              }
              let linkStdDci = this._scheduleDocService.LinkStdDciDoc(docIdinput).subscribe((result) => {
                if (result) {
                  result.forEach((element: { std_Doc_No: any; }) => {
                    let suceessdoc = {
                      doc_no: element.std_Doc_No,
                      successcode: 200,
                      successmessage: "Document Linked Successfully"
                    }
                    this.addeddata.push(suceessdoc);
                  });
                  this.selectionAction = [];
                  this.eleValue = [];
                  this.eleobj = [];
                  this.selectedWorkflownumber = 0;
                  this.selectedgroup_Id = 0;
                  this.selectedReleaseId = 0;
                  this.Responce(this.addeddata);
                  this.loadStandardDrawingList();
                }
                else {
                  let errordoc = {
                    doc_no: null,
                    successcode: 500,
                    successmessage: "Error - Documents Not Linked"
                  }
                  this.addeddata.push(errordoc);
                  this.selectionAction = [];
                  this.eleValue = [];
                  this.eleobj = [];
                  this.selectedWorkflownumber = 0;
                  this.selectedgroup_Id = 0;
                  this.selectedReleaseId = 0;
                  this.Responce(this.addeddata);
                  this.loadStandardDrawingList();
                }
              });
              this.UnsubscribeArray.push(linkStdDci);
            }
            else {
              this._notificationService.showToast("Please Select Workflow", "Warning");
            }
          }
          else {
            this._notificationService.showToast("No Documents Selected", "Warning");
          }
  
        }
      });
    }
    else
    {
      this._notificationService.showToast("No Documents Selected", "Warning");
    }

    

    // this.selectedfiles = [];
    // this.SDdocIDforLink = [];
    // if (this.selectionAction.length > 0) {
    //   this.selectionAction.forEach(element => {
    //     if (element.isSelected) {
    //       this.selectedfiles.push(element);
    //     }
    //   });
    //   this.selectedfiles.forEach(element => {

    //     let i = this.selectedfiles.indexOf(element);
    //     let obj = {
    //       "doc_id": this.selectedfiles[i].doc_Id
    //     };
    //     this.SDdocIDforLink.push(obj);
    //   });
    //   if (this.selectedWorkflownumber != 0) {
    //     let docIdinput: SDLinkModel =
    //     {
    //       intProjectId: this.projectId,
    //       intGroupID: this.groupId,
    //       strjsonDocID: JSON.stringify(this.SDdocIDforLink),

    //       intWFID: this.selectedWorkflownumber,
    //       intUID: this.memberId
    //     }
    //     let linkStdDci = this._scheduleDocService.LinkStdDciDoc(docIdinput).subscribe((result) => {
    //       if (result) {
    //         result.forEach((element: { std_Doc_No: any; }) => {
    //           let suceessdoc = {
    //             doc_no: element.std_Doc_No,
    //             successcode: 200,
    //             successmessage: "Document Linked Successfully"
    //           }
    //           this.addeddata.push(suceessdoc);
    //         });
    //         this.selectionAction = [];
    //         this.Responce(this.addeddata);
    //         this.loadStandardDrawingList();
    //       }
    //       else {
    //         let errordoc = {
    //           doc_no: null,
    //           successcode: 500,
    //           successmessage: "Error - Documents Not Linked"
    //         }
    //         this.addeddata.push(errordoc);
    //         this.selectionAction = [];
    //         this.Responce(this.addeddata);
    //         this.loadStandardDrawingList();
    //       }
    //     });
    //     this.UnsubscribeArray.push(linkStdDci);
    //   }
    //   else {
    //     this._notificationService.showToast("Please Select Workflow", "Warning");
    //   }
    // }
    // else {
    //   this._notificationService.showToast("No Documents Selected", "Warning");
    // }
  }

  Responce(result: any[]) {
    let dialogRef = this.dialog.open(StandardDrawingDialogComponent,
      {
        panelClass: 'mat-dialog-content',
        data: result,
        maxHeight: '100%'
      });
    dialogRef.afterClosed().subscribe((data) => {
      this.loadStandardDrawingList();
      this.addeddata = [];
      this.selectionAction = [];
    });
  }

  super_doc(dataItem: any)
  {
    this._notificationService.showPopup("Are you sure you want to Supersede this Document", 'Confirm').then(data => {
      if (data == 'yes') 
      {
        let obj = {
          "doc_Id" : dataItem.doc_Id
        };
        this._scheduleDocService.PostSupersedeStdDraw(obj).subscribe(res => {
          if(res[0].doc_Id != null)
          {
            this._notificationService.showToast("Document Superseded Successfully", "Success");
            const dialog = this.dialog.open(FileUploadComponent, {
                panelClass: 'mat-dialog-secondary',
                width: '50%',
                data: {
                    projectId: 0,
                    docId: res[0].doc_Id ,
                    revisionNo: res[0].revision_No ,
                    moduleName: 'EDMS',
                    libraryName: FileUploadLibrary.WorkflowDocument,
                    createdBy: this.memberId,
                    documents: [{
                        value: res[0].doc_Id,
                        text: dataItem.doc_No,
                        revisionNo: res[0].revision_No,
                        task_SNo: 1
                    }],
                    isEditable: false
                },
            });
            dialog.afterClosed().subscribe((res: any) => {
              this.loadStandardDrawingList();
            });
          }
          else
          {
            this._notificationService.showToast("Error in Superseding the Document", "Warning");
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}

